import { api } from "@/lib/api/client";
import type { components } from "@/types/api";

export type ApiKey = components["schemas"]["ApiKey"];
export type ApiKeyWithSecret = components["schemas"]["ApiKeyWithSecret"];
export type ApiKeyScope = components["schemas"]["ApiKeyScope"];

/**
 * GET /v1/api-keys
 */
export async function listApiKeys(): Promise<ApiKey[]> {
  const data = await api.get<{ api_keys: ApiKey[] }>("/v1/api-keys");
  return data.api_keys;
}

/**
 * POST /v1/api-keys
 */
export function createApiKey(body: {
  name: string;
  scopes: ApiKeyScope[];
  expires_at?: string | null;
}): Promise<ApiKeyWithSecret> {
  return api.post<ApiKeyWithSecret>("/v1/api-keys", body);
}

/**
 * DELETE /v1/api-keys/:id (soft-revoke)
 */
export function revokeApiKey(id: string): Promise<ApiKey> {
  return api.delete<ApiKey>(`/v1/api-keys/${id}`);
}

/**
 * PATCH /v1/api-keys/:id
 */
export function renameApiKey(id: string, name: string): Promise<ApiKey> {
  return api.patch<ApiKey>(`/v1/api-keys/${id}`, { name });
}
